<template>
  <div class="personal-data page">
    <div class="wrapper" v-if="switchUserInfo.length > 0">
      <div class="title">管理我的账号</div>
      <div class="wrapList">
        <div
          class="item acea-row row-between-wrapper"
          :class="item.shopId === userInfo.shopId ? 'on' : ''"
          v-for="(item, index) in switchUserInfo"
          :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper">
            <div class="pictrue">
              <div class="pictrue">
                <img :src="item.picture" />
              </div>
              <img
                src="@assets/images/alter.png"
                class="alter"
                v-if="item.shopId === userInfo.shopId"
              />
            </div>
            <div class="text">
              <div class="name line1">{{ item.shopName }}</div>
              <div class="phone">姓名：{{ item.trueName }}</div>
              <div class="phone">绑定手机号：{{ item.phone }}</div>
            </div>
          </div>
          <div
            class="currentBnt acea-row row-center-wrapper font-color-red"
            v-if="item.shopId === userInfo.shopId"
          >
            当前账号
          </div>
          <div
            class="bnt font-color-red acea-row row-center-wrapper"
            v-else
            @click="switchAccounts(index)"
          >
            使用账号
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { switchUser, getUserShop } from "@api/user";
import { clearAuthStatus } from "@libs/wechat";
import $store from "@/store";

export default {
  components: {},
  data: function () {
    return {
      isWeixin: false,
      currentAccounts: 0,
      switchUserInfo: [],
      userIndex: 0,
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    userInfo: {
      handler(val, oldVal) {
        this.getUserInfo();
      },
    },
  },
  mounted: function () {
    this.getUserInfo();
  },
  methods: {
    switchAccounts: function (index) {
      let user = this.switchUserInfo[index];

      if (this.switchUserInfo.length <= 1) return true;
      if (user === undefined) {
        return this.$dialog.toast({ mes: "切换的账号不存在" });
      }

      switchUser(user.id).then((res) => {
        if (res.code == 200) {
          clearAuthStatus();
          let data = res.result;
          this.$store.commit("LOGIN", data);
          this.$store.dispatch("USERINFO", true).then(() => {
            this.$router.replace({ path: "/user" });
          });
        }
      });
    },
    getUserInfo: function () {
      getUserShop().then((res) => {
        this.switchUserInfo = res.result;
      });
    },
  },
};
</script>
<style scoped>
.personal-data .wrapper .wrapList .item .picTxt .pictrue {
  width: 1rem;
  height: 1rem;
}
</style>
